import { ErrorCode } from '@cpd-app/core-module/models';
export enum ErrorCodeType {
  NotFound = '404',
  RequestTimeout = '408',
  ServerError = '500',
  Unauthorized = '401',
  SessionExpired = '403',
  Maintenance = 'maintenance'
}
export const ERROR_CODES: ErrorCode[] = [
  {
    code: ErrorCodeType.NotFound,
    title: 'Page Not Found',
    description:
      "It seems like the path you're looking for has taken a detour. The team is working to fix this route, please try again later!"
  },
  {
    code: ErrorCodeType.RequestTimeout,
    title: 'Request Timeout',
    description:
      "It seems like the path you're on has taken too long. The team is working to fix this route, please try again later!"
  },
  {
    code: ErrorCodeType.ServerError,
    title: 'Server Error',
    description:
      "It seems like the path you're looking for has taken a detour. The team is working to fix this route, please try again later!"
  },
  {
    code: ErrorCodeType.Unauthorized,
    // QA.20: this is "your account cannot open this page", not an outage.
    title: 'No access to this page',
    description:
      'Your account does not have access to this page. If you think it should, ask your DCPD administrator or email supportcpd@vantagepoint-inc.com.'
  },
  {
    code: ErrorCodeType.SessionExpired,
    title: 'Session Expired',
    description:
      "It seems like the path you're on has ended. \n Please click the button below to go back home!"
  },
  {
    code: ErrorCodeType.Maintenance,
    title: 'Website Under Maintenance ',
    description:
      'The website is currently undergoing a scheduled maintenance. We should be back shortly.'
  }
];
